<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="proName ? ('Edit ' | translate) + (proName | shortName) + (' Tip' | translate) : ''"
      [class]="extraClass"
      [canGoBack]="false"
      [noBow]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    <tidy-row [align]="'center'" class="extra-bottom-padding">
      <tidy-text
        [body]="'Enter the new tip amount here. You can edit tips for 48 hours.'" />
    </tidy-row>

    <tidy-card>
      <form [formGroup]="form">
        <tidy-row class="field-top-padding">
          <tidy-input
            formControlName="tipValue"
            [label]="'New Amount'"
            [inputMode]="'numeric'"
            [form]="form.controls.tipValue"
            [submitted]="submitted"
            [icon]="'assets/svg/cash.svg'"
            [errorMessage]="'Please enter a valid amount.'" />
        </tidy-row>
      </form>
    </tidy-card>

    <tidy-error-message
      [text]="errorMessage" />

    <tidy-two-column-row>
      <tidy-button
        [text]="'Go Back'"
        [action]="boundGoBack"
        class="secondary" />
      <tidy-button
        [text]="'Edit Tip'"
        class="primary"
        [action]="boundSubmit" />
    </tidy-two-column-row>

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
